import { useDispatch } from 'react-redux';
import { DraggableCore } from 'react-draggable';
import * as finderActions from '../actions';

const MIN_HEIGHT = 150;
const REST_HEIGHT = 300; // в стилях тоже есть эти 300px - даже если слот не двигали, надо обеспечить запас высоты для остального контента

export const SlotDragHandler = () => {
  const dispatch = useDispatch();

  const findSlotElement = () =>
    document.querySelector<HTMLDivElement>('.al-finder-details__image-slot');

  return (
    <DraggableCore
      onStart={() => {
        dispatch(finderActions.setSlotDragging({ slotDragging: true }));
        const slot = findSlotElement();
        if (slot) {
          dispatch(finderActions.slotHeightChanged({ slotHeight: slot.offsetHeight }));
        }
      }}
      onDrag={(e, data) => {
        let newHeight = Math.max(data.y, MIN_HEIGHT);
        const slot = findSlotElement();
        if (slot?.parentElement) {
          newHeight = Math.min(newHeight, slot.parentElement.clientHeight - REST_HEIGHT);
        }
        dispatch(finderActions.slotHeightChanged({ slotHeight: newHeight }));
      }}
      onStop={() => {
        dispatch(finderActions.setSlotDragging({ slotDragging: false }));
      }}
    >
      <div className="al-finder-slot-drag-handler" />
    </DraggableCore>
  );
};
